export var QueryKeys = /*#__PURE__*/ function(QueryKeys) {
    QueryKeys["LegalTerms"] = "LegalTerms";
    QueryKeys["Relationship"] = "Relationship";
    QueryKeys["Draft"] = "Draft";
    QueryKeys["ArchivedProposals"] = "ArchivedProposals";
    QueryKeys["CanResyncQbo"] = "CanResyncQbo";
    QueryKeys["CanResyncXero"] = "CanResyncXero";
    QueryKeys["ServiceTemplatesForBilling"] = "ServiceTemplatesForBilling";
    QueryKeys["Contacts"] = "Contacts";
    QueryKeys["ContactsMap"] = "ContactsMap";
    QueryKeys["ActiveServices"] = "ActiveServices";
    QueryKeys["ProposalTemplates"] = "ProposalTemplates";
    QueryKeys["ServiceBillingDetails"] = "ServiceBillingDetails";
    QueryKeys["GetInfo"] = "getInfo";
    QueryKeys["PromptSuggestions"] = "PromptSuggestions";
    QueryKeys["RichText"] = "RichText";
    QueryKeys["PdfUrl"] = "PdfUrl";
    QueryKeys["BillingSchedule"] = "BillingSchedule";
    QueryKeys["UserReferral"] = "UserReferral";
    QueryKeys["PayoutsSummary"] = "PayoutsSummary";
    QueryKeys["SalesSummary"] = "SalesSummary";
    QueryKeys["HistoricAgreementStats"] = "HistoricAgreementStats";
    QueryKeys["MonthlyEarnings"] = "MonthlyEarnings";
    QueryKeys["HistoricRevenueStats"] = "HistoricRevenueStats";
    QueryKeys["InvoicesDigest"] = "InvoicesDigest";
    QueryKeys["Proposals"] = "Proposals";
    QueryKeys["Drafts"] = "Drafts";
    QueryKeys["ActivityLog"] = "ActivityLog";
    QueryKeys["CustomPageTemplates"] = "CustomPageTemplates";
    QueryKeys["CustomPageDownloadUrl"] = "CustomPageDownloadUrl";
    QueryKeys["Invoice"] = "Invoice";
    return QueryKeys;
}({});
